export const GET_INVITES = 'GET_INVITES';
export const GET_INVITES_SUCCESS = 'GET_INVITES_SUCCESS';
export const GET_INVITES_FAILURE = 'GET_INVITES_FAILURE';
export const SEND_INVITE = 'SEND_INVITE';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_FAILURE = 'SEND_INVITE_FAILURE';
export const APPROVE_INVITE = 'APPROVE_INVITE';
